/* H4: small progressive enhancements. Without this file every page stays readable. */
/* phone corridor (home): cover flow. A sideways swipe row, nothing is pinned: the centred clip is flat and its neighbours lean
   away behind it. It opens on the second clip, so there is a neighbour on each side. The layout comes from body.h4-cflow
   (h4-home.css). Only the centred clip may play: the others carry data-h4-hold, which the play-in-view block below respects.
   Without this script the plain swipe gallery stays. */
(function () {
  function init() {
    var st = document.querySelector('body.h4-home .corr .stage');
    if (!st || st.h4cf || !window.matchMedia || !matchMedia('(max-width:820px)').matches) return;
    var sc = st.querySelector('.vids'), bl = st.querySelector('.cfn .cl'), br = st.querySelector('.cfn .cr');
    if (!sc) return;
    st.h4cf = true;
    document.body.classList.add('h4-cflow');
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* the clips that show on phones, in the order the stylesheet gives them */
    var cards = [].filter.call(sc.querySelectorAll('.vc'), function (c) { return getComputedStyle(c).display !== 'none'; });
    cards.sort(function (a, b) { return (parseInt(getComputedStyle(a).order, 10) || 0) - (parseInt(getComputedStyle(b).order, 10) || 0); });
    var N = cards.length;
    if (!N) return;
    var boxes = cards.map(function (c) { return c.querySelector('.vb'); }), vs = cards.map(function (c) { return c.querySelector('video'); });
    var rtl = getComputedStyle(sc).direction === 'rtl', act = -1, tick = false, touched = false;
    function mid(el) { var r = el.getBoundingClientRect(); return r.left + r.width / 2; }
    function play() {
      vs.forEach(function (v, n) {
        if (!v) return;
        if (n === act) { v.removeAttribute('data-h4-hold'); if (v.h4in && !reduce && v.paused) { var q = v.play(); if (q && q.catch) q.catch(function () {}); } }
        else { v.setAttribute('data-h4-hold', ''); if (!v.paused) v.pause(); }
      });
    }
    function off(b, n) { if (!b) return; var x = n < 0 || n > N - 1; b.classList.toggle('is-off', x); b.disabled = x; }
    function upd() {
      tick = false;
      var m = mid(sc), best = 0, bd = 1e9;
      cards.forEach(function (c, n) {
        /* the figure itself is never transformed, so its box is the true scroll position */
        var r = c.getBoundingClientRect(), w = r.width || 1, d = (r.left + w / 2 - m) / w, a = Math.abs(d), k = Math.min(a, 1), sg = d < 0 ? -1 : 1, b = boxes[n];
        if (a < bd) { bd = a; best = n; }
        if (!b) return;
        if (a > 3.2) { b.style.visibility = 'hidden'; return; }
        b.style.visibility = '';
        b.style.transform = 'translateX(' + (-sg * w * (0.36 * k + 0.52 * Math.max(0, a - 1))).toFixed(1) + 'px) perspective(900px) rotateY(' + (-52 * sg * k).toFixed(2) + 'deg) scale(' + (1 - 0.16 * k).toFixed(3) + ')';
        b.style.opacity = (1 - 0.22 * Math.max(0, a - 1)).toFixed(3);
        c.style.zIndex = 100 - Math.round(a * 10);
      });
      if (best !== act) {
        act = best;
        cards.forEach(function (c, n) { c.classList.toggle('is-act', n === act); });
        /* the arrows are physical (left, right): which one means "next" depends on the reading direction */
        off(bl, act + (rtl ? 1 : -1)); off(br, act + (rtl ? -1 : 1));
        play();
      }
    }
    function go(n, now) {
      n = Math.max(0, Math.min(N - 1, n));
      var dx = mid(cards[n]) - mid(sc);
      if (now || reduce || !sc.scrollBy) sc.scrollLeft += dx; else sc.scrollBy({ left: dx, behavior: 'smooth' });
    }
    function ask() { if (!tick) { tick = true; requestAnimationFrame(upd); } }
    if (bl) bl.addEventListener('click', function () { touched = true; go(act + (rtl ? 1 : -1)); });
    if (br) br.addEventListener('click', function () { touched = true; go(act + (rtl ? -1 : 1)); });
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (t) { sc.addEventListener(t, function () { touched = true; }, { passive: true }); });
    sc.addEventListener('scroll', ask, { passive: true });
    /* until the visitor moves it, the row keeps the second clip in the middle (also after a rotation or a fold) */
    function home() { go(touched ? Math.max(0, act) : Math.min(1, N - 1), true); upd(); }
    window.addEventListener('resize', home);
    window.addEventListener('load', function () { if (!touched) home(); });
    home();
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vids = [].slice.call(document.querySelectorAll('video[data-h4-auto]'));
  vids.forEach(function (v) { v.muted = true; v.setAttribute('preload', 'none'); });
  if (!vids.length || reduce || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      v.h4in = e.isIntersecting;   /* the phone cover flow reads this, and holds every clip but the centred one */
      if (e.isIntersecting && !v.hasAttribute('data-h4-hold')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { rootMargin: '120px 0px', threshold: 0.15 });
  vids.forEach(function (v) { io.observe(v); });
})();
/* posters of videos below the first screen: when a section gets near the screen, all its videos get their poster
   (per section and not per video, so cards waiting sideways in a swipe gallery are ready before they slide in) */
(function () {
  var lazy = [].slice.call(document.querySelectorAll('video[data-poster]'));
  if (!lazy.length) return;
  function set(v) { var p = v.getAttribute('data-poster'); if (p) { v.poster = p; v.removeAttribute('data-poster'); } }
  if (!('IntersectionObserver' in window)) { lazy.forEach(set); return; }
  var boxes = [];
  lazy.forEach(function (v) { var b = v.closest('section') || v.parentNode; if (boxes.indexOf(b) < 0) boxes.push(b); });
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      [].forEach.call(e.target.querySelectorAll('video[data-poster]'), set); io.unobserve(e.target);
    });
  }, { rootMargin: '1400px 0px' });
  boxes.forEach(function (b) { io.observe(b); });
})();
/* product page on phones: the sticky buy bar steps aside while the dark closing section, with its own buy button, is on screen */
(function () {
  var bar = document.querySelector('body.h4-product .mbar'), last = document.querySelector('body.h4-product section.last');
  if (!bar || !last || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (es) {
    es.forEach(function (e) { bar.classList.toggle('is-off', e.isIntersecting); });
  }, { rootMargin: '0px 0px -70px 0px' }).observe(last);
})();
/* product page on phones: the page pill steps aside while scrolling down and returns on scrolling up */
(function () {
  var pill = document.querySelector('body.h4-product nav.pill');
  if (!pill || !window.matchMedia || !matchMedia('(max-width:820px)').matches) return;
  var last = window.pageYOffset, tick = false;
  window.addEventListener('scroll', function () {
    if (tick) return; tick = true;
    requestAnimationFrame(function () {
      tick = false;
      var y = window.pageYOffset, d = y - last;
      if (Math.abs(d) < 8) return;
      pill.classList.toggle('is-away', d > 0 && y > 300);
      last = y;
    });
  }, { passive: true });
})();
